// Rating keys (English text -> numeric value)
export const RATING_KEYS = {
    TERRIBLE: 1,
    BAD: 2,
    OK: 3,
    GOOD: 4,
    EXCELLENT: 5
};

// Rating labels in Hebrew
export const RATING_LABELS_HEBREW = {
    [RATING_KEYS.TERRIBLE]: "נורא",
    [RATING_KEYS.BAD]: "רע",
    [RATING_KEYS.OK]: "בסדר",
    [RATING_KEYS.GOOD]: "טוב",
    [RATING_KEYS.EXCELLENT]: "מעולה"
};

// Rating labels mapping (for backward compatibility)
export const RATING_LABELS = RATING_LABELS_HEBREW;

// Positive feedback options (for rating >= 4)
export const FEEDBACK_OPTIONS = [
    {id: "productVariety", label: "מגוון מוצרים"},
    {id: "valueForMoney", label: "תמורה למחיר"},
    {id: "deliveryExperience", label: "חווית המשלוח"},
    {id: "productQuality", label: "איכות המוצרים"}
];

// Issue/negative feedback options (for rating <= 2)
export const ISSUE_OPTIONS = [
    {id: "missingProducts", label: "חסרים מוצרים"},
    {id: "deliveryDelay", label: "איחור בזמן המשלוח"},
    {id: "badProductQuality", label: "איכות המוצרים"},
    {id: "other", label: "אחר"}
];

// Map frontend option IDs to backend enum values
export const RATING_ASPECT_MAP = {
    // Positive feedback options
    productVariety: "productVariety",
    valueForMoney: "valueForMoney",
    deliveryExperience: "deliveryExperience",
    productQuality: "productQuality",
    // Issue/negative feedback options
    missingProducts: "missingProducts",
    deliveryDelay: "deliveryDelay",
    badProductQuality: "badProductQuality",
    other: "other"
};

export const ORDER_RATING_FIELDS = ["eventId", "proposalId", "productName", "orderName", "rating", "providerBrand"];

export const ORDER_INFO_PROJECTION = {
    fields: {
        orders: ORDER_RATING_FIELDS
    }
};

export const MAX_FILE_SIZE_MB = 5;
